import { taskActivityActionType } from '../../constants/index';

export default (state = {}, action) => {
  switch (action.type) {
    case taskActivityActionType.FETCH_ACTIVITY_MEMBERS:
      return {
        ...state,
        "taskActivityMembersList": action.payload
      };
    case taskActivityActionType.FETCH_ACTIVITY_CALLHISTORY:
      return {
        ...state,
        "taskActivityCallHistory": action.payload
      };
    case taskActivityActionType.FETCH_ACTIVITY_SUCCESS:
      return {
        ...state,
        "taskActivityPostSuccess": action.payload
      };
    case taskActivityActionType.FETCH_ACTIVITY_CALLHISTORY_API:
      return {
        ...state,
        "taskActivityCallHistoryAPI": action.payload
      };
    default:
      return state;
  }
};
